export default __webpack_public_path__ + "static/media/video-image-4.b85ec456.png";